import { Building2Icon } from 'assets/icons';

// A company in a list: the building in its square, its trade name over its
// company name (lighter and smaller, 13 px), cut short past 230 px so the
// other columns keep their room. `tag`: a badge beside the trade name (the
// size of the client), which the name gives way to.
const CompanyIdentity = ({ name, legalName, tag }) => (
  <span className="flex min-w-0 max-w-[230px] items-center gap-3">
    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-gray-200 bg-white text-gray-700">
      <Building2Icon wh={20} color="currentColor" />
    </span>
    <span className="min-w-0">
      <span className="flex min-w-0 items-center gap-2">
        <span className="truncate font-medium uppercase text-gray-900">{name}</span>
        {tag && <span className="shrink-0">{tag}</span>}
      </span>
      <span className="block truncate text-[13px] font-light uppercase leading-[18px] text-gray-400">{legalName || '-'}</span>
    </span>
  </span>
);

export default CompanyIdentity;
